import React, { useState } from "react";
import "./ChatBot.css";

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { type: "bot", text: "Hi there! 👋 Welcome to Study Overseas. Can I take a few details before we proceed?" },
  ]);
  const [step, setStep] = useState("ask-confirm");
  const [userDetails, setUserDetails] = useState({ name: "", email: "", phone: "" });

  const addMessage = (type, text) => {
    setMessages((prev) => [...prev, { type, text }]);
  };

  const handleUserInput = (input) => {
    addMessage("user", input);

    if (step === "ask-confirm") {
      addMessage("bot", "Great! What’s your full name?");
      setStep("ask-name");
    } else if (step === "ask-name") {
      setUserDetails({ ...userDetails, name: input });
      addMessage("bot", `Thanks, ${input}! What's your email address?`);
      setStep("ask-email");
    } else if (step === "ask-email") {
      setUserDetails({ ...userDetails, email: input });
      addMessage("bot", "Got it. Can you share your phone number? (optional)");
      setStep("ask-phone");
    } else if (step === "ask-phone") {
      setUserDetails({ ...userDetails, phone: input });
      addMessage("bot", `Thanks ${userDetails.name || ""}! Now, how can I assist you today?`);
      addMessage("bot", "Please choose one of the options below 👇");
      setStep("ask-service");
    }
  };

  const handleServiceChoice = (service) => {
    addMessage("user", service);
    setStep("done");

    switch (service) {
      case "Explore Universities":
        addMessage("bot", "We partner with top universities in the UK, USA, Germany, Australia, and more. Visit the 'Universities' section to explore by country.");
        break;
      case "Scholarships":
        addMessage("bot", "You can find scholarships for undergraduate, postgraduate, and PhD programs. Visit our 'Scholarships' section for eligibility and deadlines.");
        break;
      case "Visa Process":
        addMessage("bot", "Our team guides you step-by-step through your visa application. Check the 'Visa Support' page for detailed country-specific info.");
        break;
      case "Book Counseling":
        addMessage("bot", "You can book a one-on-one counseling session with our expert advisors. Visit the 'Book a Session' page to schedule your slot.");
        break;
      case "Other Queries":
        addMessage("bot", "Please type your question, and our team will get back to you shortly!");
        break;
      default:
        addMessage("bot", "Let me know how else I can assist you!");
    }
  };

  return (
    <div className="chatbot-container">
      <div className={`chat-window ${isOpen ? "open" : ""}`}>
        <div className="chat-header" onClick={() => setIsOpen(!isOpen)}>
          Study Abroad ChatBot
        </div>
        <div className="chat-body">
          {messages.map((msg, idx) => (
            <div key={idx} className={`chat-message ${msg.type}`}>
              {msg.text}
            </div>
          ))}

          {(step === "ask-confirm" || step === "ask-name" || step === "ask-email" || step === "ask-phone") && (
            <UserInput onSubmit={handleUserInput} />
          )}

          {step === "ask-service" && (
            <div className="chat-options">
              {["Explore Universities", "Scholarships", "Visa Process", "Book Counseling", "Other Queries"].map((service) => (
                <button key={service} onClick={() => handleServiceChoice(service)}>
                  {service}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <button className="chat-toggle" onClick={() => setIsOpen(!isOpen)}>
        💬
      </button>
    </div>
  );
};

const UserInput = ({ onSubmit }) => {
  const [input, setInput] = useState("");
  return (
    <div className="chat-input">
      <input
        type="text"
        placeholder="Type your answer..."
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && input.trim() && (onSubmit(input.trim()), setInput(""))}
      />
      <button onClick={() => input.trim() && (onSubmit(input.trim()), setInput(""))}>Send</button>
    </div>
  );
};

export default ChatBot;
